<template>
  <div id="results">
    <!-- modals -->
    <b-modal :active.sync="flags.flightReview" has-modal-card>
      <review-modal></review-modal>
    </b-modal>
    <b-modal
      class="modal-padded"
      :active.sync="isModifySearch"
      has-modal-card
      trap-focus
    >
      <search-engine></search-engine>
    </b-modal>
    <sidebar-mobile ref="sidebar" class="sidebar mobile-only"></sidebar-mobile>
    <div class="main-content">
      <div class="tool-bar mobile-only">
        <div class="tool-bar__item" v-on:click="orderTypeList = !orderTypeList">
          <i class="fas fa-list-ol"></i>
          Order By
          <div v-if="orderTypeList" class="order-dropdown">
            <div
              v-for="orderType in orderTypes"
              :key="orderType.index"
              class="order-dropdown-item"
              @click="setOrderType(orderType)"
            >
              {{ orderType }}
            </div>
          </div>
        </div>
        <div class="tool-bar__item" v-on:click="openSidebar()">
          <i class="fas fa-sliders-h"></i>
          Show Filters
        </div>
        <div class="tool-bar__item" v-on:click="isModifySearch = true">
          <i class="fas fa-search"></i>
          Modify Search
        </div>
      </div>
      <taskbar
        class="desktop-only"
        :class="{ 'fixed-taskbar': isFixed, 'top-index': !flags.modalOpen }"
      ></taskbar>
      <flight-list></flight-list>
    </div>
    <sidebar-desktop class="sidebar desktop-only"></sidebar-desktop>
  </div>
</template>

<script>
import FlightList from "@/components/FlightList.vue";
import SidebarDesktop from "@/components/SidebarDesktop.vue";
import SidebarMobile from "@/components/SidebarMobile.vue";
import ReviewModal from "@/components/TripReviewModal.vue";
import SearchEngine from "@/components/SearchEngine.vue";
import Taskbar from "@/components/Taskbar.vue";
import { mapState } from "vuex";

export default {
  name: "results",
  data: function() {
    return {
      orderTypeList: false,
      orderTypes: ["Price", "Time"],
      selectedOrder: "Price",
      isModifySearch: false,
      scrollDistance: 0,
    };
  },
  computed: {
    ...mapState(["flags"]),
    isFixed() {
      return this.scrollDistance > 120 ? true : false;
    },
  },
  methods: {
    openSidebar() {
      this.$refs.sidebar.toggleSidebar();
    },
    setOrderType(orderType) {
      this.selectedOrder = orderType;
      this.$store.commit("orderResults", this.selectedOrder);
    },
    toggleReviewModal() {
      this.$store.commit("toggleFlightReview");
    },
    onScroll(e) {
      this.scrollDistance = window.top.scrollY;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  components: {
    FlightList,
    SidebarDesktop,
    SidebarMobile,
    ReviewModal,
    Taskbar,
    SearchEngine,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.main-content {
  margin: 0.75em;
}

.tool-bar {
  width: 100%;
  max-width: 600px;
  background: $light;
  margin: auto;
  padding: 0.75em;
  display: flex;
  flex-wrap: nowrap;
  border-radius: 8px;
  align-items: center;
  justify-content: space-around;
  color: #919191;
  font-size: 0.8em;
  * + * {
    margin-left: 0.2em;
  }
  i {
    color: #2c3e50;
  }
  .tool-bar__item {
    padding: 0.6em;
    width: 40%;
    text-align: center;
    font-size: 0.9em;
  }
  .order-dropdown {
    position: absolute;
    width: 80px;
    margin-top: 10px;
    margin-left: -8px !important;
    border: solid 1px #919191;
    border-radius: 3px;
    background: white;
    * + * {
      border-top: 1px dashed $primary-dark;
    }
    .order-dropdown-item {
      padding: 0.6em 0.3em;
      margin: 0;
      cursor: pointer;
    }
    .order-dropdown-item:hover {
      background: $secondary-color;
    }
  }
  .book-button {
    font-size: 1em;
  }
}

@media (min-width: 781px) {
  #results {
    margin: auto;
    margin-top: 2em;
    display: grid;
    grid-template-columns: 200px 1fr 1fr 1fr;
    grid-template-rows: auto;
    grid-auto-rows: minmax(10px, auto);
    grid-column-gap: 1.5em;
    grid-row-gap: 1.5em;
    overflow-x: visible;
    grid-template-areas: "sidebar main main main";
  }
  .main-content {
    margin: 0;
    grid-area: main;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 860px;
  }
  #flight-list {
    width: 100%;
  }
  .sidebar {
    grid-area: sidebar;
    align-self: start;
    margin-bottom: 30px;
  }
  #taskbar {
    width: 98.5%;
    margin: auto;
    margin-bottom: 0.5em;
    margin-top: 0.1em;
  }
  .fixed-taskbar {
    position: fixed;
    top: 5px;
    width: 858px !important;
    box-shadow: 0 1px 7px rgba(32, 33, 36, 0.6) !important;
    animation-name: taskbar-fixed;
    animation-duration: 1.5s;
  }
  .top-index {
    z-index: 39;
  }
}

@media (min-width: 1025px) {
  #results {
    width: 1080px;
  }
}
</style>

<style lang="scss">
.modal-padded {
  padding: 8px;
}

.animation-content {
  z-index: 1;
  min-width: 300px;
}

@media screen and (max-width: 781px) {
  .dropdown.is-mobile-modal > .dropdown-menu {
    top: 30% !important;
  }
}
</style>
